function extractSectionId(element) {
	element = element.classList.contains("shopify-section") ? element : element.closest(".shopify-section");
	return element.id.replace("shopify-section-", "");
}

(()=> {
	const button = document.querySelector("[data-collection-show-more-button]");

	if (!button) {
		return null;
	}

	button.addEventListener("click", showMore);
})()

function showMore () {
	const button = document.querySelector("[data-collection-show-more-button]");
	const paginationTarget = document.querySelector("[data-collection-show-more-target]");
	const productsWrapper = document.querySelector("[data-collection-products-wrapper]");

	if (!paginationTarget && !productsWrapper) {
		return null;
	}
	const currentPage = paginationTarget.getAttribute("data-current-page");
	const nextPage = currentPage*1+1;
	const totalPages = paginationTarget.getAttribute("data-pages-total-count");
	const sectionId = extractSectionId(button);

	if (currentPage !== totalPages) {
		const nextPageUrl = new URL(location.origin + paginationTarget.getAttribute("data-next-page-url"));
		nextPageUrl.searchParams.set("section_id", sectionId)
		window.collectionInLoading = true;

		fetch(nextPageUrl)
			.then(response => response.text())
			.then(text => {
				const tempDiv = new DOMParser().parseFromString(text, "text/html")
				const tempPaginationTarget = tempDiv.querySelector("[data-collection-show-more-target]");
				const tempProductCards = tempDiv.querySelectorAll(".js-pagination-target");

				tempProductCards.forEach(productCard => {
					productsWrapper.appendChild(productCard)
				})

				const upratedCurrentPage = tempPaginationTarget.getAttribute("data-current-page");
				const upratedNextUrl = tempPaginationTarget.getAttribute("data-next-page-url");
				paginationTarget.setAttribute("data-current-page", upratedCurrentPage);
				paginationTarget.setAttribute("data-next-page-url", upratedNextUrl);
				window.collectionInLoading = false;
				Shopify.AjaxifyCart.init();
				document.dispatchEvent(new CustomEvent("initProductCards"))
			}).catch(error => {
			window.collectionInLoading = false;
			console.error(error);
		})
	}
	if (nextPage == totalPages){
		button.classList.add("hidden");
	};
}
